<div
  class="card modern-card full-width"
  >
  <div class="card-header border-0 pt-3 px-4 sticky-header">
    <div class="d-flex justify-content-between align-items-center">
      <div class="header-content">
        <h1 class="modern-header">Accounting Options</h1>
      </div>
    </div>
  </div>

  <div class="card-body px-4 pb-4">
    <form
      [formGroup]="this.accountingOptionsForm"
      (ngSubmit)="onSubmit()"
      >
      <!-- General Accounting Options Section -->
      <div class="row mb-3">
        <div class="col-12">
          <h4 class="mb-0 text-light border-bottom border-secondary pb-2 d-flex justify-content-between align-items-center section-toggle"
            (click)="showGeneralOptions = !showGeneralOptions">
            General Accounting Options
            <i class="fa" [class.fa-chevron-down]="showGeneralOptions" [class.fa-chevron-right]="!showGeneralOptions"></i>
          </h4>
        </div>
      </div>

      <div [collapse]="!showGeneralOptions" [isAnimated]="true">
        <!-- Costing Method -->
        <div class="row mb-4">
          <div class="col-12 form-group d-flex align-items-start mb-0">
            <label class="form-label-long" for="costing_method_for_inventory"
              >Costing Method for Inventory:</label
              >
              <div class="flex-grow-1">
                <div class="d-flex align-items-center gap-2">
                  <ng-select
                    [items]="inventory_cost_method_options"
                    [multiple]="false"
                    [closeOnSelect]="true"
                    [clearable]="false"
                    appendTo="body"
                    class="form-control text-uppercase p-0 border-0 bg-transparent"
                    formControlName="costing_method_for_inventory"
                    id="costing_method_for_inventory"
                    style="width: 250px"
                  ></ng-select>
                  @if (costingMethodLocked) {
                    <span class="text-warning small ms-1" tooltip="Cost method cannot be changed after inventory transactions have been recorded" placement="right">
                      <i class="fa fa-lock"></i> Locked
                    </span>
                  }
                </div>
                <div class="mt-2">
                  @if (
                    accountingOptionsForm.get("costing_method_for_inventory")
                    .value === "FIFO"
                    ) {
                    <span class="info-text text-info small">
                      Assumes that the earliest goods purchased are sold first.
                      Costs are assigned based on the order of acquisition.
                    </span>
                  }
                  @if (
                    accountingOptionsForm.get("costing_method_for_inventory")
                    .value === "LIFO"
                    ) {
                    <span class="info-text text-info small">
                      Assumes that the latest goods purchased are sold first.
                      Costs are assigned based on the reverse order of acquisition.
                    </span>
                  }
                  @if (
                    accountingOptionsForm.get("costing_method_for_inventory")
                    .value === "Average"
                    ) {
                    <span class="info-text text-info small">
                      Calculates the cost of goods sold by averaging the cost of all
                      inventory items available.
                    </span>
                  }
                </div>
              </div>
            </div>
          </div>

          <!-- Accounting Basis -->
          <div class="row mb-4">
            <div class="col-12 form-group d-flex align-items-start mb-0">
              <label class="form-label-long" for="cash_accrual_basis"
                >Accounting Basis:</label
                >
                <div class="flex-grow-1">
                  <ng-select
                    [items]="accounting_basis"
                    [multiple]="false"
                    [closeOnSelect]="true"
                    [clearable]="false"
                    appendTo="body"
                    class="form-control text-uppercase p-0 border-0 bg-transparent"
                    formControlName="cash_accrual_basis"
                    id="cash_accrual_basis"
                    style="width: 250px"
                    [tooltip]="'Only Cash Basis is available'"
                    placement="right"
                  ></ng-select>
                  <div class="mt-2">
                    @if (
                      accountingOptionsForm.get("cash_accrual_basis").value ===
                      "Cash Basis"
                      ) {
                      <span class="info-text text-info small">
                        The set of rules a business uses to record and report its
                        income and expenses.
                      </span>
                    }
                    @if (
                      accountingOptionsForm.get("cash_accrual_basis").value ===
                      "Accrual Basis"
                      ) {
                      <div class="info-text text-info small">
                        This method records income when it's earned and expenses when
                        they're incurred, regardless of when cash changes hands. It is
                        required by GAAP for certain businesses and provides a more
                        accurate long-term view of a company's finances.
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div> <!-- end collapse: showGeneralOptions -->

          @if (!otherSectionsEnabled) {
            <div class="alert alert-warning mt-4">
              <i class="fa fa-exclamation-triangle me-2"></i>
              Please select a <span style="font-weight: 500">Costing Method for Inventory</span> above to unlock the remaining options.
            </div>
          }

          <!-- Sale Receipt Options Section -->
          @if (otherSectionsEnabled) {
            <div>
              <div class="row mb-3 mt-4">
                <div class="col-12">
                  <h4 class="mb-0 text-light border-bottom border-secondary pb-2 d-flex justify-content-between align-items-center section-toggle"
                    (click)="showReceiptOptions = !showReceiptOptions">
                    Sale Receipt Options
                    <i class="fa" [class.fa-chevron-down]="showReceiptOptions" [class.fa-chevron-right]="!showReceiptOptions"></i>
                  </h4>
                </div>
              </div>
              <div [collapse]="!showReceiptOptions" [isAnimated]="true">
                <!-- Sales Receipt Message -->
                <div class="row mb-3">
                  <div class="col-12 form-group d-flex align-items-start mb-0">
                    <label class="form-label-long" for="default_sales_receipt_message"
                      >Default Message on Sales Receipt:</label
                      >
                      <div class="flex-grow-1">
                        <textarea
                          class="form-control"
                          formControlName="default_sales_receipt_message"
                          id="default_sales_receipt_message"
                          style="height: 100px"
                          maxlength="255"
                        ></textarea>
                        <div class="text-end small mt-1" [class.text-danger]="accountingOptionsForm.get('default_sales_receipt_message').value?.length >= 255" [class.text-secondary]="accountingOptionsForm.get('default_sales_receipt_message').value?.length < 255">
                          {{ accountingOptionsForm.get('default_sales_receipt_message').value?.length || 0 }} / 255
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Statement Message -->
                  <div class="row mb-4">
                    <div class="col-12 form-group d-flex align-items-start mb-0">
                      <label
                        class="form-label-long"
                        for="default_message_on_sales_statement"
                        >Default Message on Statement:</label
                        >
                        <div class="flex-grow-1">
                          <textarea
                            class="form-control"
                            formControlName="default_message_on_sales_statement"
                            id="default_message_on_sales_statement"
                            style="height: 100px"
                            maxlength="255"
                          ></textarea>
                          <div class="text-end small mt-1" [class.text-danger]="accountingOptionsForm.get('default_message_on_sales_statement').value?.length >= 255" [class.text-secondary]="accountingOptionsForm.get('default_message_on_sales_statement').value?.length < 255">
                            {{ accountingOptionsForm.get('default_message_on_sales_statement').value?.length || 0 }} / 255
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> <!-- end collapse: showReceiptOptions -->
                  <!-- Chart of Accounts Section -->
                  <div class="row mb-3 mt-4">
                    <div class="col-12">
                      <h4 class="mb-0 text-light border-bottom border-secondary pb-2 d-flex justify-content-between align-items-center section-toggle"
                        (click)="showChartOfAccounts = !showChartOfAccounts">
                        Chart of Accounts
                        <i class="fa" [class.fa-chevron-down]="showChartOfAccounts" [class.fa-chevron-right]="!showChartOfAccounts"></i>
                      </h4>
                    </div>
                  </div>
                  <div [collapse]="!showChartOfAccounts" [isAnimated]="true">
                    <!-- Accounts table: Income | Expense side by side -->
                    <div class="row mb-4 mt-2">
                      <!-- Income column -->
                      <div class="col-6">
                        <div class="coa-column">
                          <div class="coa-column-header coa-income-header">
                            <i class="fa fa-arrow-up me-2"></i>Income
                          </div>
                          <!-- Built-in defaults (read-only, top of column) -->
                          @for (acct of defaultIncomeAccounts; track acct.name) {
                            <div class="coa-row coa-row-default">
                              <span>{{ acct.name }}</span>
                            </div>
                          }
                          <!-- Custom accounts (drag to reorder, × to remove) -->
                          @if (customIncomeAccounts.length) {
                            <bs-sortable
                              [(ngModel)]="customIncomeAccounts"
                              [ngModelOptions]="{standalone: true}"
                              [itemTemplate]="customIncomeItem"
                              itemClass="coa-row coa-row-custom sortable-item"
                              itemActiveClass="sortable-item-active"
                              wrapperClass="sortable-wrapper">
                            </bs-sortable>
                          }
                        </div>
                      </div>
                      <!-- Expense column -->
                      <div class="col-6">
                        <div class="coa-column">
                          <div class="coa-column-header coa-expense-header">
                            <i class="fa fa-arrow-down me-2"></i>Expense
                          </div>
                          <!-- Built-in defaults (read-only, top of column) -->
                          @for (acct of defaultExpenseAccounts; track acct.name) {
                            <div class="coa-row coa-row-default">
                              <span>{{ acct.name }}</span>
                            </div>
                          }
                          <!-- Custom accounts (drag to reorder, × to remove) -->
                          @if (customExpenseAccounts.length) {
                            <bs-sortable
                              [(ngModel)]="customExpenseAccounts"
                              [ngModelOptions]="{standalone: true}"
                              [itemTemplate]="customExpenseItem"
                              itemClass="coa-row coa-row-custom sortable-item"
                              itemActiveClass="sortable-item-active"
                              wrapperClass="sortable-wrapper">
                            </bs-sortable>
                          }
                        </div>
                      </div>
                      <!-- Row templates for the sortable customs.
                      bs-sortable wraps each value in { value, index, initData }. -->
                      <ng-template #customIncomeItem let-item="item">
                        <i class="fa fa-grip-vertical drag-handle me-2" title="Drag to reorder"></i>
                        <span class="flex-grow-1">{{ item.value }}</span>
                        <button type="button" class="btn btn-link btn-sm text-danger p-0 ms-2"
                          (click)="removeCustomIncomeAccount(item.value)" title="Remove">
                          <i class="fa fa-times"></i>
                        </button>
                      </ng-template>
                      <ng-template #customExpenseItem let-item="item">
                        <i class="fa fa-grip-vertical drag-handle me-2" title="Drag to reorder"></i>
                        <span class="flex-grow-1">{{ item.value }}</span>
                        <button type="button" class="btn btn-link btn-sm text-danger p-0 ms-2"
                          (click)="removeCustomExpenseAccount(item.value)" title="Remove">
                          <i class="fa fa-times"></i>
                        </button>
                      </ng-template>
                    </div>
                    <!-- Add custom account form -->
                    <div class="row mb-4">
                      <div class="col-12 d-flex align-items-center gap-2 flex-wrap">
                        <ng-select
                          class="compact-app-select"
                          style="width: 130px"
                          [items]="accountTypeOptions"
                          [searchable]="false"
                          [clearable]="false"
                          [(ngModel)]="newAccountType"
                          [ngModelOptions]="{standalone: true}"
                        ></ng-select>
                        <input type="text" class="form-control" style="max-width: 280px"
                          placeholder="Account name"
                          [(ngModel)]="newAccountName" [ngModelOptions]="{standalone: true}"
                          (keydown.enter)="$event.preventDefault(); addCustomAccount()" />
                          <button type="button" class="btn grey-btn" style="color:white"
                            (click)="addCustomAccount()"
                            [disabled]="!newAccountName?.trim()">
                            <i class="fa fa-plus me-1"></i>Add Account
                          </button>
                        </div>
                      </div>
                    </div> <!-- end collapse: showChartOfAccounts -->
                    <!-- Sales Tax Rates Section -->
                    <div class="row mb-3 mt-4">
                      <div class="col-12">
                        <h4 class="mb-0 text-light border-bottom border-secondary pb-2 d-flex justify-content-between align-items-center section-toggle"
                          (click)="showSalesTaxRates = !showSalesTaxRates">
                          Sales Tax Rates
                          <i class="fa" [class.fa-chevron-down]="showSalesTaxRates" [class.fa-chevron-right]="!showSalesTaxRates"></i>
                        </h4>
                      </div>
                    </div>
                    <div [collapse]="!showSalesTaxRates" [isAnimated]="true">
                      <div class="row mb-4 mt-2">
                        <div class="col-12">
                          <!-- Rates table -->
                          <table class="table table-sm table-dark table-hover mb-3">
                            <thead>
                              <tr>
                                <th>Name</th>
                                <th class="text-end">State</th>
                                <th class="text-end">County</th>
                                <th class="text-end">City</th>
                                <th class="text-end">Special</th>
                                <th class="text-end">Combined</th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              @for (t of salesTaxOptions; track t.name; let i = $index) {
                                <tr>
                                  <td>{{ t.name }}</td>
                                  <td class="text-end">{{ (t.state_rate * 100) | number:'1.2-4' }}%</td>
                                  <td class="text-end">{{ (t.county_rate * 100) | number:'1.2-4' }}%</td>
                                  <td class="text-end">{{ (t.city_rate * 100) | number:'1.2-4' }}%</td>
                                  <td class="text-end">{{ (t.special_rate * 100) | number:'1.2-4' }}%</td>
                                  <td class="text-end fw-medium">{{ (t.combined_rate * 100) | number:'1.2-4' }}%</td>
                                  <td class="text-end">
                                    <button type="button" class="btn btn-link btn-sm text-danger p-0"
                                      (click)="removeTaxRate(i)" title="Remove">
                                      <i class="fa fa-times"></i>
                                    </button>
                                  </td>
                                </tr>
                              }
                            </tbody>
                          </table>
                          <!-- Add new rate row -->
                          <div class="d-flex align-items-center gap-2 flex-wrap mb-2">
                            <input type="text" class="form-control" style="max-width: 200px"
                              placeholder="Name (e.g. Idaho – Ada Co.)"
                              [(ngModel)]="newTax.name" [ngModelOptions]="{standalone: true}" />
                              <div class="d-flex align-items-center gap-1">
                                <label class="text-light small mb-0">State %</label>
                                <input type="number" class="form-control form-control-sm tax-rate-input"
                                  [(ngModel)]="newTax.state_rate" [ngModelOptions]="{standalone: true}" min="0" max="100" step="0.01" />
                                </div>
                                <div class="d-flex align-items-center gap-1">
                                  <label class="text-light small mb-0">County %</label>
                                  <input type="number" class="form-control form-control-sm tax-rate-input"
                                    [(ngModel)]="newTax.county_rate" [ngModelOptions]="{standalone: true}" min="0" max="100" step="0.01" />
                                  </div>
                                  <div class="d-flex align-items-center gap-1">
                                    <label class="text-light small mb-0">City %</label>
                                    <input type="number" class="form-control form-control-sm tax-rate-input"
                                      [(ngModel)]="newTax.city_rate" [ngModelOptions]="{standalone: true}" min="0" max="100" step="0.01" />
                                    </div>
                                    <div class="d-flex align-items-center gap-1">
                                      <label class="text-light small mb-0">Special %</label>
                                      <input type="number" class="form-control form-control-sm tax-rate-input"
                                        [(ngModel)]="newTax.special_rate" [ngModelOptions]="{standalone: true}" min="0" max="100" step="0.01" />
                                      </div>
                                      <span class="text-light small">= {{ (newTaxCombined * 100) | number:'1.2-4' }}% combined</span>
                                      <button type="button" class="btn grey-btn" style="color:white"
                                        (click)="addTaxRate()" [disabled]="!newTax.name?.trim()">
                                        <i class="fa fa-plus me-1"></i>Add Rate
                                      </button>
                                    </div>
                                    <p class="text-light small fst-italic">
                                      Enter rates as decimals (e.g. 6% = 0.06). Combined rate is used on sales receipts.
                                    </p>
                                  </div>
                                </div>
                              </div> <!-- end collapse: showSalesTaxRates -->
                              <!-- Payment Options Section -->
                              <div class="row mb-3 mt-4">
                                <div class="col-12">
                                  <h4 class="mb-0 text-light border-bottom border-secondary pb-2 d-flex justify-content-between align-items-center section-toggle"
                                    (click)="showPaymentOptions = !showPaymentOptions">
                                    Payment Options
                                    <i class="fa" [class.fa-chevron-down]="showPaymentOptions" [class.fa-chevron-right]="!showPaymentOptions"></i>
                                  </h4>
                                </div>
                              </div>
                              <div [collapse]="!showPaymentOptions" [isAnimated]="true">
                                <!-- Two columns side by side, matching the Chart of Accounts layout -->
                                <div class="row mb-4 mt-2">
                                  <!-- Payment Accounts column -->
                                  <div class="col-6">
                                    <div class="coa-column">
                                      <div class="coa-column-header coa-payment-account-header">
                                        <i class="fa fa-university me-2"></i>Payment Accounts
                                      </div>
                                      <!-- Built-in defaults (read-only, top of column) -->
                                      @for (a of accountingService.payment_account_defaults; track a) {
                                        <div class="coa-row coa-row-default">
                                          <span>{{ a }}</span>
                                        </div>
                                      }
                                      <!-- Customs (drag to reorder, × to remove) -->
                                      @if (paymentAccounts.length) {
                                        <bs-sortable
                                          [(ngModel)]="paymentAccounts"
                                          [ngModelOptions]="{standalone: true}"
                                          [itemTemplate]="paymentAccountItem"
                                          itemClass="coa-row coa-row-custom sortable-item"
                                          itemActiveClass="sortable-item-active"
                                          wrapperClass="sortable-wrapper">
                                        </bs-sortable>
                                      }
                                    </div>
                                  </div>
                                  <!-- Payment Methods column -->
                                  <div class="col-6">
                                    <div class="coa-column">
                                      <div class="coa-column-header coa-payment-method-header">
                                        <i class="fa fa-credit-card me-2"></i>Payment Methods
                                      </div>
                                      <!-- Built-in defaults (read-only, top of column) -->
                                      @for (m of accountingService.payment_method_defaults; track m) {
                                        <div class="coa-row coa-row-default">
                                          <span>{{ m }}</span>
                                        </div>
                                      }
                                      <!-- Customs (drag to reorder, × to remove) -->
                                      @if (paymentMethods.length) {
                                        <bs-sortable
                                          [(ngModel)]="paymentMethods"
                                          [ngModelOptions]="{standalone: true}"
                                          [itemTemplate]="paymentMethodItem"
                                          itemClass="coa-row coa-row-custom sortable-item"
                                          itemActiveClass="sortable-item-active"
                                          wrapperClass="sortable-wrapper">
                                        </bs-sortable>
                                      }
                                    </div>
                                  </div>
                                  <!-- Row templates: rendered for each sortable item.
                                  bs-sortable wraps every value in { value, index, initData },
                                  so we display item.value and use item.index for removal. -->
                                  <ng-template #paymentAccountItem let-item="item">
                                    <i class="fa fa-grip-vertical drag-handle me-2" title="Drag to reorder"></i>
                                    <span class="flex-grow-1">{{ item.value }}</span>
                                    <button type="button" class="btn btn-link btn-sm text-danger p-0 ms-2"
                                      (click)="removePaymentAccount(item.value)" title="Remove">
                                      <i class="fa fa-times"></i>
                                    </button>
                                  </ng-template>
                                  <ng-template #paymentMethodItem let-item="item">
                                    <i class="fa fa-grip-vertical drag-handle me-2" title="Drag to reorder"></i>
                                    <span class="flex-grow-1">{{ item.value }}</span>
                                    <button type="button" class="btn btn-link btn-sm text-danger p-0 ms-2"
                                      (click)="removePaymentMethod(item.value)" title="Remove">
                                      <i class="fa fa-times"></i>
                                    </button>
                                  </ng-template>
                                </div>
                                <!-- Add payment entry form (matches Chart of Accounts add-row UX) -->
                                <div class="row mb-4">
                                  <div class="col-12 d-flex align-items-center gap-2 flex-wrap">
                                    <ng-select
                                      class="compact-app-select"
                                      style="width: 180px"
                                      [items]="paymentTypeOptions"
                                      [searchable]="false"
                                      [clearable]="false"
                                      [(ngModel)]="newPaymentType"
                                      [ngModelOptions]="{standalone: true}"
                                    ></ng-select>
                                    <input type="text" class="form-control" style="max-width: 280px"
                                      placeholder="Name"
                                      [(ngModel)]="newPaymentName" [ngModelOptions]="{standalone: true}"
                                      (keydown.enter)="$event.preventDefault(); addPaymentEntry()" />
                                      <button type="button" class="btn grey-btn" style="color:white"
                                        (click)="addPaymentEntry()" [disabled]="!newPaymentName?.trim()">
                                        <i class="fa fa-plus me-1"></i>Add
                                      </button>
                                    </div>
                                  </div>
                                </div> <!-- end collapse: showPaymentOptions -->
                              </div>
                              } <!-- end *ngIf="otherSectionsEnabled" wrapper -->
                              <!-- Credit Card Processing Rate -->
                              <div class="row mb-3 mt-4">
                                <div class="col-12">
                                  <h4 class="mb-0 text-light border-bottom border-secondary pb-2">
                                    Credit Card Processing Rate
                                  </h4>
                                </div>
                              </div>
                              <div class="row mb-4">
                                <div class="col-12 form-group d-flex align-items-start mb-0">
                                  <label class="form-label-long" for="credit_card_processing_rate">Credit Card Processing Rate (%):</label>
                                  <div class="flex-grow-1">
                                    <input
                                      type="number"
                                      step="0.01"
                                      id="credit_card_processing_rate"
                                      class="form-control"
                                      style="max-width: 150px"
                                      placeholder="e.g. 3.5"
                                      formControlName="credit_card_processing_rate"
                                    />
                                    <small class="text-secondary d-block mt-1">This rate is used to calculate estimated processing fees.</small>
                                  </div>
                                </div>
                              </div>

                              <!-- Buttons -->
                              <div class="row save-btn-row">
                                <div class="col-12 d-flex justify-content-end">
                                  <button
                                    class="btn green-btn"
                                    style="color: white; width: 200px"
                                    type="submit"
                                    [disabled]="this.accountingOptionsForm.invalid"
                                    >
                                    <i class="fa fa-save me-2"></i>Save Options
                                  </button>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
